import Bacon from "./Components/HelpScout/Bacon";

import './Components';
import './Library/Keyboard';
import './Library/Sortable';
import './MainEventBus';

import './htmx-2.0.8.min.js';

new Bacon();
